const Cate = () => import('@/views/cate') // 分类
const ProductList = () => import('@/views/products') // 商品列表
const ProductDetail = () => import('@/views/product') // 商品详情
const ProductShare = () => import('@/views/productShare') // 商品分享
const Profits = () => import('@/views/profits') // 我的收益(已结算,待结算,金豆)
const Orders = () => import('@/views/orders') // 我的订单

export default [
  { path: '/cate', name: 'cate', component: Cate, meta: { keepAlive: true, title: '分类' } },
  { path: '/product/list', name: 'productList', component: ProductList, meta: { keepAlive: true, title: '商品列表' } },
  { path: '/product/detail', name: 'productDetail', component: ProductDetail, meta: { keepAlive: false, title: '商品详情' } },
  { path: '/product/share', name: 'productShare', component: ProductShare, meta: { keepAlive: false, title: '创建分享' } },
  { path: '/order/list', name: 'orders', component: Orders, meta: { keepAlive: false, requireAuth: true, title: '我的订单' } },
  { path: '/user/profits', name: 'profits', component: Profits, meta: { keepAlive: false, requireAuth: true, title: '我的收益' } },
]